<template>
      <button type="button" class="-ml-3 mr-1 whitespace-no-wrap bg-green-500"
        @click="copyHtml"
      >
        Copy Email Template
      </button>
</template>

<script>
export default {
  props: {
    content: '',
  },

  methods: {
    copyHtml() {
      var container = document.createElement('div');
      container.innerHTML = this.content;
      container.style.position = 'fixed';
      container.style.pointerEvents = 'none';
      container.style.opacity = 0;

      document.body.appendChild(container);

      window.getSelection().removeAllRanges();
      var range = document.createRange();
      range.selectNode(container);
      window.getSelection().addRange(range);

      document.execCommand('copy');
      document.body.removeChild(container);

      alert('The email template has been copied to your clipboard.');
    },
  },
}
</script>
